import _ from 'lodash'
import { Renewal } from 'src/renewal/interfaces/renewal_types'

// When reviving an IP right, it can happen that there are two MAs with the same due date. In this case, we want to eliminate the one that is not open or not active.
export function eliminateDoubleRenewals<T extends Renewal>(maintenanceActions?: T[]) {
  const maintenanceActionsByYear = _(maintenanceActions ?? [])
    .groupBy(m => m.feeDueDate?.slice(0, 4) ?? '-')
    .mapValues(ms => {
      if (ms.length === 1) return ms[0]
      else {
        const open = ms.filter(m => m.instruction === undefined)
        // let's hope l -1 gives us the last one; can't say anything else about the ordering...
        if (open.length > 0) return open[open.length - 1]

        const nonInactive = ms.filter(m => m.state !== 'Cancelled')
        if (nonInactive.length > 0) return nonInactive[nonInactive.length - 1]

        return ms[ms.length - 1]
      }
    })
    .value()
  return maintenanceActionsByYear
}